import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserTable from "./UserTable.js";
import UserForm from "./UserForm.js";
import SearchBar from "../SearchBar.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchUsers,
  createUser,
  updateUserApi,
  deleteUserApi,
  createAdmin,
} from "../../services/apiServices.js";
import "../../assets/css/UserManagement.css";
const UserManagement = ({authUser}) => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const roleRaw = authUser?.role || localStorage.getItem("role");
    const role = roleRaw ? String(roleRaw).trim().toLowerCase() : null;

    if (!role || ( role !== "superadmin")) {
      console.error("unauthorized to access User Management", { role, authUser });
      localStorage.clear();
      navigate("/login", { replace: true });
    }
  }, [authUser, navigate]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await fetchUsers();
        setUsers(list?.users || []);
      } catch (_) {
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const addUser = async (user) => {
    try {
      const created = await createUser(user);
      setUsers((prev) => [...prev, created]);
      toast.success("User added successfully");
      return users;
    } catch (err) {
      toast.error(err.message || "Error adding user");
    }
  };
  const addAdmin = async (user) => {
    try {
      const created = await createAdmin(user, authUser.role);
      setUsers((prev) => [...prev, created]);
      toast.success("User added successfully");
      return users;
    } catch (err) {
      toast.error(err.message || "Error adding admin");
    }
  };

  const deleteUser = async (id, userToDelete) => {
    try {
      const deletedUser = await deleteUserApi(id, userToDelete, authUser.role);
      if (deletedUser) {
        setUsers((prev) => prev.filter((u) => u.id !== id));
        toast.success("User deleted successfully");
      }
    } catch (err) {
      toast.error(err.message || "Failed to delete user");
    }
  };

  const updateUser = async (id, updated) => {
    try {
      const saved = await updateUserApi(id, updated, authUser.role);
      if (saved) {
        setUsers((prev) =>
          prev.map((u) => (u.id === id ? { ...u, ...saved } : u))
        );
        toast.success("User updated successfully");
      }
    } catch (err) {
      toast.error(err.message || "Failed to update user");
    }
  };

  const filteredUsers = users.filter(
    (u) =>
      (u.firstName || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.lastName || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.email || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.status || "").toLowerCase().includes(search.toLowerCase())
  );

  if (loading)
    return (
      <div className="user-manage">
        <div className="header-row">
          <h1>Loading...</h1>
        </div>
      </div>
    );

  return (
    <div className="user-manage">
      <div className="header-row">
        <h1>User Management</h1>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span>{authUser?.email}</span>
          <UserForm addUser={addUser} authUser={authUser} addAdmin={addAdmin} />
        </div>
      </div>
      <SearchBar search={search} setSearch={setSearch} />
      <UserTable
        users={filteredUsers}
        deleteUser={deleteUser}
        updateUser={updateUser}
      />
      <ToastContainer />
    </div>
  );
};

export default UserManagement;
